<template>
    <div>
        <span :class="labelClass" :title="`${data.total_compliant_pts}/${data.total_inspected_pts} Compliant`" v-if="score !== null" :style="extraStyles">
        {{ score }}%
        </span>
        <span v-else>--</span>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default(){
                    return {};
                }
            },

            displayType: {
                type: String,
                default: 'text',
            },

            extraStyles: {
                type: String,
                default: '',
            },
        },

        data: function() {
            return {
                color: 'success',
            }
        },

        computed: {

            score(){
                //Send it
                var score = null;

                //Check if the data has the FIXED score set
                if(typeof this.data.insp_score != 'undefined' && this.data.insp_score !== null)
                {
                    score = this.data.insp_score;
                }
                else if (parseInt(this.data.total_inspected_pts) > 0)
                {
                    score = (parseInt(this.data.total_compliant_pts) / parseInt(this.data.total_inspected_pts) * 100).toFixed(2);
                }

                //Default
                this.color = 'success';

                //Get the color
                if(score < 90 && score >= 80)
                {
                    this.color = 'warning';
                }
                else if(score < 80)
                {
                    this.color = 'danger';
                }

                return score;
            },

            labelClass(){
                //Setup
                var classes = '';

                //Build the Class
                switch(this.displayType)
                {
                    case 'badge':
                        //Append
                        classes += 'badge badge-' + this.color;
                        break;

                    default:
                        //Append
                        classes += 'text-' + this.color;
                        break;
                }

                //Send it
                return classes;
            },

        },

        methods: {

        },

        mounted(){

        }
    }
</script>
